import styled from 'styled-components';

export const ToggleSwitchWrapperStyled = styled.div`
  display: flex;
  position: relative;
  cursor: pointer;
`;
export const CheckBoxLabelStyled = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  width: 29px;
  height: 16px;
  border-radius: 15px;
  background: #ffffff;
  border: 1px solid #d3d3d3;

  &::after {
    content: '';
    display: block;
    border-radius: 50%;
    width: 10px;
    height: 10px;
    margin: 2px;
    background: #d3d3d3;
    transition: 0.2s;
  }
`;
export const CheckBoxStyled = styled.input`
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 29px;
  height: 16px;

  &:checked + ${CheckBoxLabelStyled} {
    background: ${({ theme }) => theme.primaryColour};
    border-color: ${({ theme }) => theme.primaryColour};

    &::after {
      content: '';
      display: block;
      background: #ffffff;
      border-radius: 50%;
      width: 10px;
      height: 10px;
      margin-left: 15px;
      transition: 0.2s;
    }
  }
`;
